import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './PaginationTable.css';
import { initPagination } from 'components/shared/pagination/table/store/actions';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import {
  currentPageSelector,
  paginationPageSizeSelector,
  paginationTotalSelector,
} from 'components/shared/pagination/table/store/selectors';

class PaginationTable extends Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    onCurrentPageChange: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onInit();
  }

  render() {
    const {
      children,
      currentPage,
      pageSize,
      total,
      onCurrentPageChange,
    } = this.props;
    return (
      <div className="pagination-table">
        {children}
        <div className="pagination-container">
          <SimplePagination
            currentPage={currentPage}
            pageSize={pageSize}
            total={total}
            onPageChange={onCurrentPageChange}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentPage: currentPageSelector(state),
    pageSize: paginationPageSizeSelector(state),
    total: paginationTotalSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onInit: () => {
    dispatch(initPagination());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaginationTable);



// WEBPACK FOOTER //
// ./src/components/shared/pagination/table/PaginationTable.js